<ng-container *ngIf="lazyCount; else regularPagination">
  <div class="order-pagination w-100" role="navigation" aria-label="Phân trang đơn hàng">
    <div class="order-pagination__summary" aria-live="polite">
      <span class="order-pagination__range">{{ itemCount ? 'Đang xem đơn ' : 'Không có đơn hàng ở trang này' }}<strong *ngIf="itemCount">{{ startItem | number }}–{{ endItem | number }}</strong></span>
      <span *ngIf="total !== null && total !== undefined" class="order-pagination__total">trong tổng số <strong>{{ total | number }}</strong> đơn</span>
      <button *ngIf="total === null || total === undefined" type="button" class="order-pagination__count" title="Bấm xem tổng số đơn hàng để đi đến trang bất kỳ" [disabled]="countLoading" (click)="countRequested.emit()">
        <span *ngIf="countLoading" class="spinner-border spinner-border-sm" aria-hidden="true"></span>
        <i *ngIf="!countLoading" class="ri-calculator-line" aria-hidden="true"></i>
        {{ countLoading ? 'Đang đếm số đơn...' : 'Xem tổng số đơn' }}
      </button>
    </div>
    <div class="order-pagination__controls">
      <span class="order-pagination__current" aria-live="polite">Trang {{ currentPage || 1 }}<ng-container *ngIf="total !== null && total !== undefined"> / {{ maxPage }}</ng-container></span>
      <button *ngIf="hasPreviousPage" type="button" class="btn btn-outline-secondary" (click)="lazyPageSet((currentPage || 1) - 1)"><i class="ri-arrow-left-s-line" aria-hidden="true"></i> Trang trước</button>
      <button *ngIf="hasNextPage" type="button" class="btn btn-outline-secondary" (click)="lazyPageSet((currentPage || 1) + 1)">Trang sau <i class="ri-arrow-right-s-line" aria-hidden="true"></i></button>
      <label *ngIf="total !== null && total !== undefined && maxPage > 1" class="order-pagination__jump">Đến trang
        <input class="form-control" type="number" min="1" [max]="maxPage" [value]="currentPage" (change)="onLazyPageChanged($event)" aria-label="Nhập số trang rồi nhấn Enter" />
      </label>
    </div>
  </div>
</ng-container>
<ng-template #regularPagination>
<div class="d-flex align-items-center" style="gap: 8px" *ngIf="pageSizePosition === 'bottom'; else legacyGoToPage">
  <span class="text-muted">Hiển thị:</span>
  <select class="form-select form-select-sm" style="width: auto; min-width: 65px; border-radius: 6px; padding: 4px 8px;" [value]="pageSize" (change)="onPageSizeChanged($event)">
    <option *ngFor="let size of pageSizeOptions" [value]="size">{{ size }}</option>
  </select>
  <span class="text-muted">mục mỗi trang</span>
</div>
<ng-template #legacyGoToPage>
<div class="d-flex align-items-center" style="gap: 8px">
  Đi đến trang:
  <input class="form-control" style="max-width: 60px; padding: 8px; text-align: center" [value]="paginate?.currentPage"
    (change)="onPageChanged($event)" />
</div>
</ng-template>
<ul class="pagination justify-content-center"
  *ngIf="paginate?.pages && paginate?.pages.length">
  <li class="page-item" [ngClass]="{ disabled: paginate.currentPage === 1 }">
    <a class="page-link" tabindex="-1" aria-disabled="true" routerLink="." [queryParams]="{page: 1}" [queryParamsHandling]="'merge'" [replaceUrl]="true"
      (click)="pageSet(1)">
      <i class="ri-arrow-left-double-line"></i>
    </a>
  </li>
  <li class="page-item" [ngClass]="{ disabled: paginate.currentPage === 1 }">
    <a class="page-link" tabindex="-1" aria-disabled="true" routerLink="."
      [queryParams]="{page: paginate?.currentPage - 1}" [replaceUrl]="true"
      (click)="pageSet(paginate?.currentPage - 1)">
      <i class="ri-arrow-left-s-line"></i>
    </a>
  </li>
  <li class="page-item" *ngFor="let page of paginate?.pages"
    [ngClass]="{ 'active disabled': paginate.currentPage == page }" style="opacity: 1;">
    <a class="page-link" routerLink="." [queryParams]="{page: page}" [queryParamsHandling]="'merge'" [replaceUrl]="true" (click)="pageSet(page)">{{ page
      }}</a>
  </li>
  <li class="page-item" [ngClass]="{ disabled: paginate?.currentPage == paginate?.totalPages }">
    <a class="page-link" routerLink="." [queryParams]="{page: paginate?.currentPage + 1}" [queryParamsHandling]="'merge'" [replaceUrl]="true"
      (click)="pageSet(paginate?.currentPage + 1)">
      <i class="ri-arrow-right-s-line"></i>
    </a>
  </li>
  <li class="page-item" [ngClass]="{ disabled: paginate?.currentPage == paginate?.totalPages }">
    <a class="page-link" routerLink="." [queryParams]="{page: paginate?.totalPages}" [queryParamsHandling]="'merge'" [replaceUrl]="true"
      (click)="pageSet(paginate?.totalPages)">
      <i class="ri-arrow-right-double-line"></i>
    </a>
  </li>
</ul>
<div class="d-flex align-items-center" style="gap: 8px">
  Tổng số: <span>{{total}}</span>
</div>
</ng-template>
